import React from 'react';

import styles from './styles.module.scss';

/**
 * HairstyleLayout — isolated shell for the Hairstyle face-rating funnel.
 * Dark violet→magenta gradient background + a centered mobile container.
 * Each screen draws its own header / progress / button, so no shared chrome here.
 */
const HairstyleLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.root}>
    <div className={styles.bg} aria-hidden="true" />
    <div className={styles.container}>{children}</div>
  </div>
);

export default HairstyleLayout;
